import { render, staticRenderFns } from "./Fund.vue?vue&type=template&id=1985f5e4&"
import script from "./Fund.vue?vue&type=script&lang=js&"
export * from "./Fund.vue?vue&type=script&lang=js&"
import style0 from "./Fund.vue?vue&type=style&index=0&id=1985f5e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports